import { useState } from 'react';
import { MainTab } from 'components/styles_components/tab';
import { useSearchParams } from 'react-router-dom';
import { MainTabs, MainTabsContent } from 'components/styles_components/tab';

const TabsContainer = ({ tabs, content, children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const visibleTabs = tabs.filter((tab) => tab.visible);
  const paramsTab = searchParams.get('tab');
  const getTab = () => {
    if (!paramsTab) return 0;
    const byKey = visibleTabs.findIndex((t) => t.key === paramsTab);
    if (byKey >= 0) return byKey;
    const idx = parseInt(paramsTab);
    if (Number.isInteger(idx) && idx >= 0 && idx < visibleTabs.length) return idx;
    return 0;
  };
  const [tab, setTab] = useState(getTab());
  const [mountedTabs, setMountedTabs] = useState(() => new Set([getTab()]));

  const onTabChange = (_, newTab) => {
    setTab(newTab);
    setMountedTabs((prev) => {
      if (prev.has(newTab)) return prev;
      const next = new Set(prev);
      next.add(newTab);
      return next;
    });
    const key = visibleTabs[newTab]?.key;
    setSearchParams({ tab: key ?? String(newTab) });
  };

  return (
    <>
      <MainTabs value={tab} onChange={onTabChange}>
        {visibleTabs.map((tabItem, index) => (
          <MainTab key={index} label={tabItem.label} />
        ))}
      </MainTabs>
      {content.map((node, index) => (
        <MainTabsContent
          key={index}
          role="tabpanel"
          hidden={index !== tab}
          style={index !== tab ? { display: 'none' } : undefined}
        >
          {mountedTabs.has(index) ? node : null}
        </MainTabsContent>
      ))}
      {children}
    </>
  );
};

export default TabsContainer;
